import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/node_modules/next/font/google/target.css?{\"path\":\"src/app/(resource-form)/layout.tsx\",\"import\":\"Barlow\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"900\"],\"display\":\"swap\"}],\"variableName\":\"barlow\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/careerForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/generalForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/homepageForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/resourceForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/servicesForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/googleCaptchaWrapper.tsx");
